
import { useState, useEffect } from 'react';

const testimonials = [
  {
    name: 'Roberto Hernández',
    city: 'Guadalajara, Jalisco',
    rating: 5,
    text: 'El Dr. Delgadillo me operó de la próstata y todo salió perfecto. Su profesionalismo y el trato humano que recibí superaron mis expectativas. Totalmente recomendado.',
    treatment: 'RTU de Próstata'
  },
  {
    name: 'Miguel Ángel Torres',
    city: 'Zapopan, Jalisco',
    rating: 5,
    text: 'Después de años con problemas de cálculos renales, finalmente encontré la solución con el Dr. Martínez. El procedimiento fue rápido y sin complicaciones.',
    treatment: 'Litotricia'
  },
  {
    name: 'Fernando Rodríguez',
    city: 'Tlaquepaque, Jalisco',
    rating: 5,
    text: 'La atención en UROMÁS es excepcional. Desde la primera consulta me sentí cómodo y confiado. Los resultados han sido excelentes.',
    treatment: 'Tratamiento de Disfunción Eréctil'
  },
  {
    name: 'Carlos Mendoza',
    city: 'Tonalá, Jalisco',
    rating: 5,
    text: 'Profesionales de primer nivel. Me realizaron una vasectomía y todo el proceso fue muy profesional y discreto. Gracias por su excelente trabajo.',
    treatment: 'Vasectomía'
  },
  {
    name: 'Eduardo Sánchez',
    city: 'Puerto Vallarta, Jalisco',
    rating: 5,
    text: 'Vine desde Puerto Vallarta y valió completamente la pena. El Dr. Delgadillo es un excelente urólogo, muy preparado y empático.',
    treatment: 'Biopsia de Próstata'
  },
  {
    name: 'Javier Morales',
    city: 'Lagos de Moreno, Jalisco',
    rating: 5,
    text: 'El seguimiento post-operatorio ha sido excelente. Se nota que realmente se preocupan por el bienestar de sus pacientes. Muy recomendable.',
    treatment: 'Cirugía de Varicocele'
  }
];

export default function Testimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);

  useEffect(() => {
    if (!isAutoPlaying) return;
    
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => 
        prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1
      );
    }, 5000);

    return () => clearInterval(interval);
  }, [isAutoPlaying]);

  const nextTestimonial = () => {
    setCurrentIndex(currentIndex === testimonials.length - 1 ? 0 : currentIndex + 1);
    setIsAutoPlaying(false);
  };

  const prevTestimonial = () => {
    setCurrentIndex(currentIndex === 0 ? testimonials.length - 1 : currentIndex - 1);
    setIsAutoPlaying(false);
  };

  const goToSlide = (index: number) => {
    setCurrentIndex(index);
    setIsAutoPlaying(false);
  };

  return (
    <section id="testimonios" className="py-16 bg-gradient-to-br from-[#0B2A4A] to-[#1B84FF]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Lo que Dicen Nuestros Pacientes
          </h2>
          <p className="text-xl text-blue-100 max-w-3xl mx-auto">
            Testimonios reales de pacientes que han confiado en nuestros especialistas
          </p>
        </div>

        <div className="relative max-w-4xl mx-auto">
          {/* Carrusel principal */}
          <div className="bg-white rounded-2xl shadow-2xl p-8 md:p-12 min-h-[300px] flex items-center">
            <div className="w-full text-center">
              {/* Estrellas */}
              <div className="flex justify-center mb-6">
                {[...Array(testimonials[currentIndex].rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400 text-xl mx-1"></i>
                ))}
              </div>
              
              {/* Texto del testimonio */}
              <blockquote className="text-lg md:text-xl text-gray-700 leading-relaxed mb-6 italic">
                "{testimonials[currentIndex].text}"
              </blockquote>
              
              {/* Información del paciente */}
              <div className="border-t border-gray-200 pt-6">
                <p className="font-semibold text-[#111317] text-lg">
                  {testimonials[currentIndex].name}
                </p>
                <p className="text-gray-600 mb-2">
                  {testimonials[currentIndex].city}
                </p>
                <p className="text-sm text-[#1B84FF] font-medium">
                  Tratamiento: {testimonials[currentIndex].treatment}
                </p>
              </div>
            </div>
          </div>

          {/* Controles de navegación */}
          <button
            onClick={prevTestimonial}
            className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-white/90 hover:bg-white text-[#0B2A4A] w-12 h-12 rounded-full flex items-center justify-center shadow-lg transition-all duration-200 cursor-pointer"
          >
            <i className="ri-arrow-left-line text-xl"></i>
          </button>
          
          <button
            onClick={nextTestimonial}
            className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-white/90 hover:bg-white text-[#0B2A4A] w-12 h-12 rounded-full flex items-center justify-center shadow-lg transition-all duration-200 cursor-pointer"
          >
            <i className="ri-arrow-right-line text-xl"></i>
          </button>

          {/* Indicadores */}
          <div className="flex justify-center mt-8 space-x-2">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => goToSlide(index)}
                className={`w-3 h-3 rounded-full transition-all duration-200 cursor-pointer ${
                  index === currentIndex 
                    ? 'bg-white scale-125' 
                    : 'bg-white/50 hover:bg-white/75'
                }`}
              />
            ))}
          </div>
        </div>

        {/* Aviso legal */}
        <div className="mt-12 text-center">
          <p className="text-sm text-blue-100 max-w-2xl mx-auto">
            <i className="ri-information-line mr-2"></i>
            <strong>Aviso importante:</strong> Los testimonios presentados corresponden a experiencias 
            individuales y no garantizan resultados específicos. Cada caso es único y requiere 
            evaluación médica personalizada.
          </p>
        </div>
      </div>
    </section>
  );
}
